(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gc3d-reviews"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('gc3d-reviews')) {
  class GC3DReviews extends HTMLElement {
    connectedCallback() {
      this.setupFrame = requestAnimationFrame(() => this.setup());
    }

    setup() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.track = this.querySelector('[data-gcr-track]');
      if (!this.track) return;
      this.removeClones();
      this.items = [...this.track.querySelectorAll(':scope > [data-gcr-block]')];
      this.count = this.items.length;
      this.dots = this.querySelector('[data-gcr-dots]');
      this.dialog = this.querySelector('dialog');
      this.dialogContent = this.querySelector('[data-gcr-dialog-content]');
      this.prev = this.querySelector('[data-gcr-prev]');
      this.next = this.querySelector('[data-gcr-next]');
      if (!this.count || !this.dots || !this.dialog) return;
      this.current = Number.isInteger(this.current) ? this.mod(this.current) : Math.floor((this.count - 1) / 2);
      this.targetPhysical = null;
      this.suppressUntil = 0;
      this.touching = false;
      this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.items.forEach((item, index) => { item.dataset.gcrIndex = index; });
      if (this.count > 1) {
        const before = document.createDocumentFragment();
        const after = document.createDocumentFragment();
        for (let cycle = 0; cycle < 2; cycle++) {
          this.items.forEach(item => before.append(this.makeClone(item)));
          this.items.forEach(item => after.append(this.makeClone(item)));
        }
        this.track.prepend(before);
        this.track.append(after);
      }
      this.slides = [...this.track.children];
      this.buildDots(signal);
      this.prev.disabled = this.count < 2;
      this.next.disabled = this.count < 2;
      this.prev.addEventListener('click', () => this.step(-1), { signal });
      this.next.addEventListener('click', () => this.step(1), { signal });
      this.track.addEventListener('scroll', () => {
        cancelAnimationFrame(this.scrollFrame);
        this.scrollFrame = requestAnimationFrame(() => this.update());
        this.scheduleSettle();
      }, { signal, passive: true });
      this.track.addEventListener('scrollend', () => this.settle(), { signal });
      this.track.addEventListener('keydown', event => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          this.step(event.key === 'ArrowLeft' ? -1 : 1);
        } else if (event.key === 'Home' || event.key === 'End') {
          event.preventDefault();
          this.go(event.key === 'Home' ? 0 : this.count - 1);
        }
      }, { signal });
      this.track.addEventListener('pointerdown', event => {
        if (event.button !== 0 || !event.isPrimary) return;
        this.targetPhysical = null;
        this.drag = { id: event.pointerId, type: event.pointerType, x: event.clientX, y: event.clientY, scroll: this.track.scrollLeft, moved: false };
      }, { signal });
      window.addEventListener('pointermove', event => {
        if (!this.drag || this.drag.id !== event.pointerId || this.drag.type !== 'mouse') return;
        const dx = event.clientX - this.drag.x;
        if (!this.drag.moved && Math.abs(dx) > 6 && Math.abs(dx) > Math.abs(event.clientY - this.drag.y)) {
          this.drag.moved = true;
          this.track.classList.add('is-dragging');
          try { this.track.setPointerCapture(event.pointerId); } catch (_) { /* Pointer already released. */ }
        }
        if (this.drag.moved) {
          event.preventDefault();
          this.track.scrollLeft = this.drag.scroll - dx;
        }
      }, { signal, passive: false });
      const finishDrag = event => {
        if (!this.drag || this.drag.id !== event.pointerId) return;
        const mouseDrag = this.drag.type === 'mouse' && this.drag.moved;
        const moved = this.drag.moved || Math.abs(event.clientX - this.drag.x) > 8 || Math.abs(this.track.scrollLeft - this.drag.scroll) > 8;
        this.drag = null;
        this.track.classList.remove('is-dragging');
        if (moved || event.type === 'pointercancel') this.suppressUntil = performance.now() + 350;
        if (this.track.hasPointerCapture(event.pointerId)) this.track.releasePointerCapture(event.pointerId);
        if (mouseDrag) this.goPhysical(this.nearestPhysical());
        else this.scheduleSettle();
      };
      window.addEventListener('pointerup', finishDrag, { signal });
      window.addEventListener('pointercancel', finishDrag, { signal });
      this.track.addEventListener('touchstart', () => { this.touching = true; }, { signal, passive: true });
      const finishTouch = () => { this.touching = false; this.scheduleSettle(); };
      window.addEventListener('touchend', finishTouch, { signal, passive: true });
      window.addEventListener('touchcancel', finishTouch, { signal, passive: true });
      this.track.addEventListener('click', event => {
        const trigger = event.target.closest('[data-gcr-open]');
        if (!trigger) return;
        if (event.detail !== 0 && performance.now() < this.suppressUntil) {
          event.preventDefault();
          return;
        }
        this.openReview(trigger);
      }, { signal });
      this.querySelector('[data-gcr-close]').addEventListener('click', () => this.dialog.close(), { signal });
      this.dialog.addEventListener('pointerdown', event => { this.backdropStart = this.isBackdrop(event); }, { signal });
      this.dialog.addEventListener('click', event => {
        if (this.backdropStart && this.isBackdrop(event)) this.dialog.close();
        this.backdropStart = false;
      }, { signal });
      this.dialog.addEventListener('close', () => {
        this.dialogContent.replaceChildren();
        if (this.skipRestore) { this.skipRestore = false; return; }
        if (Number.isInteger(this.lastReviewIndex)) {
          this.go(this.lastReviewIndex, false);
          this.focusFrame = requestAnimationFrame(() => {
            this.items[this.lastReviewIndex]?.querySelector('[data-gcr-open]')?.focus({ preventScroll: true });
          });
        }
      }, { signal });
      document.addEventListener('shopify:block:select', event => {
        const index = this.items.findIndex(item => item.dataset.gcrBlock === event.detail?.blockId || item.contains(event.target));
        if (index < 0) return;
        if (this.dialog.open) { this.skipRestore = true; this.dialog.close(); }
        this.go(index, false);
      }, { signal });
      this.observer = new ResizeObserver(() => this.measure());
      this.observer.observe(this.track);
      window.addEventListener('resize', () => this.measure(), { signal });
      this.setAttribute('data-ready', '');
      this.measure();
    }

    mod(index) { return ((index % this.count) + this.count) % this.count; }

    makeClone(item) {
      const clone = item.cloneNode(true);
      clone.dataset.gcrClone = '';
      clone.removeAttribute('data-gcr-block');
      clone.querySelector('template')?.remove();
      [clone, ...clone.querySelectorAll('*')].forEach(node => {
        [...node.attributes].forEach(attribute => {
          if (attribute.name.startsWith('data-shopify-') || attribute.name === 'id') node.removeAttribute(attribute.name);
        });
      });
      clone.setAttribute('aria-hidden', 'true');
      clone.querySelector('[data-gcr-open]').tabIndex = -1;
      return clone;
    }

    buildDots(signal) {
      this.dots.replaceChildren();
      this.items.forEach((_, index) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'gc3d-reviews__dot';
        button.setAttribute('aria-label', `Show review ${index + 1} of ${this.count}`);
        button.setAttribute('aria-controls', this.track.id);
        const circle = document.createElement('span');
        circle.setAttribute('aria-hidden', 'true');
        button.append(circle);
        button.addEventListener('click', () => this.go(index), { signal });
        this.dots.append(button);
      });
      this.dots.hidden = this.count < 2;
    }

    measure() {
      const selected = this.targetPhysical === null ? this.current : this.mod(this.targetPhysical);
      const columns = Math.max(1, parseInt(getComputedStyle(this.track).getPropertyValue('--gcr-active-columns'), 10) || 1);
      this.visibleColumns = Math.min(columns, this.count);
      this.track.toggleAttribute('data-gcr-peek', this.count > this.visibleColumns);
      const cardWidth = this.items[0].getBoundingClientRect().width;
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      this.stepWidth = cardWidth + gap;
      this.baseLeft = this.slides[0].offsetLeft;
      const anchor = this.visibleColumns % 2 ? cardWidth / 2 : cardWidth + gap / 2;
      this.snapInset = this.track.clientWidth / 2 - anchor;
      this.track.style.setProperty('--gcr-snap-inset', `${this.snapInset}px`);
      this.jumpToPhysical((this.count > 1 ? 2 * this.count : 0) + this.mod(selected));
    }

    position(index) { return this.baseLeft + index * this.stepWidth - this.snapInset; }

    nearestPhysical() {
      if (!this.stepWidth) return 0;
      return Math.max(0, Math.min(this.slides.length - 1, Math.round((this.track.scrollLeft + this.snapInset - this.baseLeft) / this.stepWidth)));
    }

    update() {
      if (!this.stepWidth) return;
      // Resize can dispatch scroll before ResizeObserver. Preserve the selected
      // review instead of interpreting the old scroll offset with new widths.
      const measuredStep = this.items[0].getBoundingClientRect().width + (parseFloat(getComputedStyle(this.track).columnGap) || 0);
      if (Math.abs(measuredStep - this.stepWidth) > .5) { this.measure(); return; }
      this.physical = this.nearestPhysical();
      this.current = this.mod(this.physical);
      [...this.dots.children].forEach((button, index) => button.setAttribute('aria-current', String(index === this.current)));
      const bounds = this.track.getBoundingClientRect();
      this.slides.forEach(slide => {
        const box = slide.getBoundingClientRect();
        const full = box.left >= bounds.left - 1.5 && box.right <= bounds.right + 1.5;
        if (!full && slide.contains(document.activeElement) && !this.dialog.open) this.track.focus({ preventScroll: true });
        slide.setAttribute('aria-hidden', String(!full));
        slide.querySelector('[data-gcr-open]').tabIndex = full ? 0 : -1;
      });
    }

    step(delta) {
      if (this.count < 2) return;
      let from = this.targetPhysical ?? this.nearestPhysical();
      if (from + delta < this.visibleColumns + 2 || from + delta > this.slides.length - this.visibleColumns - 3) {
        from = 2 * this.count + this.mod(from);
        this.jumpToPhysical(from);
      }
      this.goPhysical(from + delta);
    }

    go(index, smooth = true) {
      const logical = this.mod(index);
      if (this.count === 1) { this.jumpToPhysical(0); return; }
      if (!smooth) { this.jumpToPhysical(2 * this.count + logical); return; }
      const from = this.targetPhysical ?? this.nearestPhysical();
      const cycle = Math.max(0, Math.min(4, Math.round((from - logical) / this.count)));
      this.goPhysical(cycle * this.count + logical);
    }

    goPhysical(index) {
      this.targetPhysical = Math.max(0, Math.min(this.slides.length - 1, index));
      this.track.scrollTo({ left: this.position(this.targetPhysical), behavior: this.reducedMotion ? 'auto' : 'smooth' });
      this.scheduleSettle();
    }

    jumpToPhysical(index) {
      cancelAnimationFrame(this.resetFrame);
      this.targetPhysical = null;
      this.track.classList.add('is-resetting');
      this.track.scrollTo({ left: this.position(index), behavior: 'auto' });
      this.update();
      this.resetFrame = requestAnimationFrame(() => {
        this.track.classList.remove('is-resetting');
        this.update();
      });
    }

    scheduleSettle() {
      clearTimeout(this.settleTimer);
      this.settleTimer = setTimeout(() => this.settle(), 180);
    }

    settle() {
      if (!this.stepWidth || this.drag || this.touching || this.dialog.open) return;
      const physical = this.nearestPhysical();
      this.targetPhysical = null;
      const centered = (this.count > 1 ? 2 * this.count : 0) + this.mod(physical);
      if (centered !== physical) this.jumpToPhysical(centered);
      else this.update();
    }

    openReview(trigger) {
      const index = Number(trigger.closest('.gc3d-reviews__item').dataset.gcrIndex);
      const template = this.items[index]?.querySelector('template');
      if (!template || this.dialog.open) return;
      this.lastReviewIndex = index;
      this.go(index, false);
      this.dialogContent.replaceChildren(template.content.cloneNode(true));
      this.dialog.setAttribute('aria-labelledby', this.dialogContent.querySelector('h3').id);
      this.dialog.setAttribute('aria-describedby', this.dialogContent.querySelector('.gc3d-reviews__full-text').id);
      this.dialog.showModal();
    }

    isBackdrop(event) {
      if (event.target !== this.dialog) return false;
      const box = this.dialog.getBoundingClientRect();
      return event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom;
    }

    removeClones() {
      this.track?.querySelectorAll('[data-gcr-clone]').forEach(item => item.remove());
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.setupFrame);
      cancelAnimationFrame(this.scrollFrame);
      cancelAnimationFrame(this.resetFrame);
      cancelAnimationFrame(this.focusFrame);
      clearTimeout(this.settleTimer);
      this.controller?.abort();
      this.observer?.disconnect();
      if (this.dialog?.open) this.dialog.close();
      this.removeClones();
      this.items?.forEach(item => { item.removeAttribute('aria-hidden'); item.querySelector('[data-gcr-open]').tabIndex = 0; });
      this.removeAttribute('data-ready');
    }
  }
  customElements.define('gc3d-reviews', GC3DReviews);
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gc3d-timeline"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gc3d-timeline')) {
    class GC3DTimeline extends HTMLElement {
      connectedCallback() { this.setupFrame = requestAnimationFrame(() => this.setup()); }

      setup() {
        this.controller?.abort();
        this.observer?.disconnect();
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.track = this.querySelector('[data-gct-track]');
        this.items = [...this.querySelectorAll('[data-gct-block]')];
        this.prev = this.querySelector('[data-gct-prev]');
        this.next = this.querySelector('[data-gct-next]');
        this.pages = this.querySelector('[data-gct-pages]');
        this.status = this.querySelector('[data-gct-status]');
        if (!this.track || !this.items.length) return;
        this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.pending = null;
        this.positions = [];
        this.current = 0;
        this.columns = null;
        this.pageCount = null;
        this.prev.addEventListener('click', () => this.step(-1), { signal });
        this.next.addEventListener('click', () => this.step(1), { signal });
        this.track.addEventListener('scroll', () => {
          cancelAnimationFrame(this.scrollFrame);
          this.scrollFrame = requestAnimationFrame(() => this.update());
          clearTimeout(this.settleTimer);
          this.settleTimer = setTimeout(() => this.settle(), 160);
        }, { signal, passive: true });
        this.track.addEventListener('keydown', event => {
          if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
            event.preventDefault();
            this.step(event.key === 'ArrowLeft' ? -1 : 1);
          } else if (event.key === 'Home' || event.key === 'End') {
            event.preventDefault();
            this.go(event.key === 'Home' ? 0 : this.positions.length - 1);
          }
        }, { signal });
        this.track.addEventListener('pointerdown', event => {
          if (!event.isPrimary || event.button !== 0) return;
          this.pending = null;
          this.drag = { id: event.pointerId, type: event.pointerType, x: event.clientX, y: event.clientY, left: this.track.scrollLeft, moved: false };
        }, { signal });
        window.addEventListener('pointermove', event => {
          if (!this.drag || this.drag.type !== 'mouse' || this.drag.id !== event.pointerId) return;
          const dx = event.clientX - this.drag.x;
          if (!this.drag.moved && Math.abs(dx) > 6 && Math.abs(dx) > Math.abs(event.clientY - this.drag.y)) {
            this.drag.moved = true;
            this.track.classList.add('is-dragging');
            try { this.track.setPointerCapture(event.pointerId); } catch (_) { /* Pointer already released. */ }
          }
          if (this.drag.moved) {
            event.preventDefault();
            this.track.scrollLeft = this.drag.left - dx;
          }
        }, { signal, passive: false });
        const finishDrag = event => {
          if (!this.drag || this.drag.id !== event.pointerId) return;
          const mouseDrag = this.drag.type === 'mouse' && this.drag.moved;
          this.drag = null;
          this.track.classList.remove('is-dragging');
          if (this.track.hasPointerCapture(event.pointerId)) this.track.releasePointerCapture(event.pointerId);
          if (mouseDrag) { this.update(); this.go(this.current); }
        };
        window.addEventListener('pointerup', finishDrag, { signal });
        window.addEventListener('pointercancel', finishDrag, { signal });
        document.addEventListener('shopify:block:select', event => {
          const index = this.items.findIndex(item => item.dataset.gctBlock === event.detail?.blockId || item.contains(event.target));
          if (index >= 0) this.go(Math.min(index, this.positions.length - 1), false);
        }, { signal });
        this.observer = new ResizeObserver(() => this.measure());
        this.observer.observe(this.track);
        this.measure();
      }

      measure() {
        const previous = this.pending ?? this.current;
        this.pending = null;
        const max = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        const starts = this.items.map(item => Math.min(max, Math.max(0, item.offsetLeft - this.items[0].offsetLeft)));
        this.positions = starts.filter((value, index) => index === 0 || Math.abs(value - starts[index - 1]) > 2);
        const columns = Math.max(1, Math.round(this.track.clientWidth / this.items[0].getBoundingClientRect().width));
        let target = Math.min(previous, this.positions.length - 1);
        if (this.columns !== columns) {
          const centered = matchMedia('(min-width: 990px)').matches && this.dataset.gctStart !== 'first';
          target = centered ? Math.floor((this.positions.length - 1) / 2) : 0;
          this.columns = columns;
        }
        if (this.pageCount !== this.positions.length) {
          this.pageCount = this.positions.length;
          this.pages.replaceChildren();
          this.positions.forEach((_, index) => {
            const button = document.createElement('button');
            button.type = 'button';
            button.className = 'gc3d-timeline__page';
            button.setAttribute('aria-label', `Show milestones ${index + 1} to ${Math.min(this.items.length, index + columns)} of ${this.items.length}`);
            button.setAttribute('aria-controls', this.track.id);
            const marker = document.createElement('span');
            marker.setAttribute('aria-hidden', 'true');
            button.append(marker);
            button.addEventListener('click', () => this.go(index), { signal: this.controller.signal });
            this.pages.append(button);
          });
        }
        this.pages.hidden = this.positions.length <= 1;
        this.go(target, false);
      }

      update() {
        if (!this.positions.length) return;
        this.current = this.positions.reduce((best, value, index) => Math.abs(value - this.track.scrollLeft) < Math.abs(this.positions[best] - this.track.scrollLeft) ? index : best, 0);
        const index = this.pending ?? this.current;
        this.prev.disabled = index <= 0;
        this.next.disabled = index >= this.positions.length - 1;
        [...this.pages.children].forEach((button, position) => button.setAttribute('aria-current', String(position === index)));
      }

      step(delta) { this.go((this.pending ?? this.current) + delta); }

      go(index, smooth = true) {
        if (!this.positions.length) return;
        this.pending = Math.max(0, Math.min(index, this.positions.length - 1));
        this.track.scrollTo({ left: this.positions[this.pending], behavior: smooth && !this.reducedMotion ? 'smooth' : 'auto' });
        this.update();
        clearTimeout(this.settleTimer);
        this.settleTimer = setTimeout(() => this.settle(), 180);
      }

      settle() {
        this.pending = null;
        this.update();
        const first = this.current + 1;
        const visible = Math.round(this.track.clientWidth / this.items[0].getBoundingClientRect().width);
        const last = Math.min(this.items.length, first + visible - 1);
        const message = `Showing milestones ${first} to ${last} of ${this.items.length}`;
        if (this.status.textContent !== message) this.status.textContent = message;
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.setupFrame);
        cancelAnimationFrame(this.scrollFrame);
        clearTimeout(this.settleTimer);
        this.controller?.abort();
        this.observer?.disconnect();
      }
    }
    customElements.define('gc3d-timeline', GC3DTimeline);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
